import styles from '@features/showrooms/sections/ShowroomSection/Components/LogoBar/LogoBar.styles';
import { BASE_PATH } from '@config/index';
import ResponsiveImage from '@components/ResponsiveImage/ResponsiveImage';
const logoScrollSpace = 1835; // sum of image widths and image margin right

const LogoBar = () => <div sx={styles.container(logoScrollSpace)}>
    <div>
      <div>
        <ResponsiveImage width={55} height={40} image={`${BASE_PATH}/img/logo/vox_white.png`} alt="vox" />
        <ResponsiveImage width={100} height={40} image={`${BASE_PATH}/img/logo/pol-skone_white.png`} alt="pol-skone" />
        <ResponsiveImage width={155} height={40} image={`${BASE_PATH}/img/logo/class-en_white.png`} alt="class-en" />
        <ResponsiveImage width={117} height={40} image={`${BASE_PATH}/img/logo/vilo_white.png`} alt="vilo" />
        <ResponsiveImage width={228} height={26} image={`${BASE_PATH}/img/logo/erkado_white.png`} alt="erkado" />
        <ResponsiveImage width={97} height={40} image={`${BASE_PATH}/img/logo/porta_white.png`} alt="porta" />
        <ResponsiveImage width={159} height={40} image={`${BASE_PATH}/img/logo/egger_white.png`} alt="egger" />
        <ResponsiveImage width={121} height={40} image={`${BASE_PATH}/img/logo/dre_white.png`} alt="dre" />
        <ResponsiveImage width={89} height={40} image={`${BASE_PATH}/img/logo/quick-step_white.png`} alt="quick-step" />
      </div>
      <div>
        <ResponsiveImage width={55} height={40} image={`${BASE_PATH}/img/logo/vox_white.png`} alt="vox" />
        <ResponsiveImage width={100} height={40} image={`${BASE_PATH}/img/logo/pol-skone_white.png`} alt="pol-skone" />
        <ResponsiveImage width={155} height={40} image={`${BASE_PATH}/img/logo/class-en_white.png`} alt="class-en" />
        <ResponsiveImage width={117} height={40} image={`${BASE_PATH}/img/logo/vilo_white.png`} alt="vilo" />
        <ResponsiveImage width={228} height={26} image={`${BASE_PATH}/img/logo/erkado_white.png`} alt="erkado" />
        <ResponsiveImage width={97} height={40} image={`${BASE_PATH}/img/logo/porta_white.png`} alt="porta" />
        <ResponsiveImage width={159} height={40} image={`${BASE_PATH}/img/logo/egger_white.png`} alt="egger" />
        <ResponsiveImage width={121} height={40} image={`${BASE_PATH}/img/logo/dre_white.png`} alt="dre" />
        <ResponsiveImage width={89} height={40} image={`${BASE_PATH}/img/logo/quick-step_white.png`} alt="quick-step" />
      </div>
    </div>
  </div>;
export default LogoBar;